import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { IndexedDBService } from '~/core/services/indexed-db-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard {
  private auth = inject(AuthenticationService);
  private router = inject(Router);

  constructor() {}

  async check(next: ActivatedRouteSnapshot) {
    const user = await IndexedDBService.getItem(AuthenticationService.localUserStoragePath);
    const isLoggedIn = AuthenticationService.currentUser;

    AuthenticationService.currentUser = user;
    this.auth.loggedInSubject.next(isLoggedIn);

    if (isLoggedIn) {
      const routeRoles = next.data.roles;
      const routeExtras = next.data.extras;
      const routeAditional = next.data.aditional;
      const extraPermission = next.data.extraPermission;
      let hasPermission = this.auth.hasPermission(routeRoles);

      if (routeExtras) {
        hasPermission = hasPermission || this.auth.hasExtraPermissions(routeExtras.profiles, routeExtras.permissions);
      }

      if (routeAditional) {
        hasPermission = hasPermission || this.auth.hasAditionalPermissions(routeAditional.profiles, routeAditional.permissions);
      }

      if (extraPermission && extraPermission.profiles === this.auth.getCurrentUser().type) {
        hasPermission = hasPermission && this.auth.hasExtraAditionalPermissions(extraPermission.profiles, extraPermission.permissions);
      }

      if (!hasPermission) {
        return this.router.navigate(['/']);
      }

      return hasPermission;
    }

    return isLoggedIn;
  }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.check(next);
  }
}
